<template>
    <transition name="fade">
        <section>
            <div class="modal fade" id="modalBank" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{doc.label}}</h5>
                        </div>
                        <div class="modal-body text-justify">

                            <div class="alert alert-info2">
                                <p class="pb-0 mb-0">Kindly ensure that the bank account declared in this application is active and can accept fund transfers, that the account is in the name of the registered business owner or of the corporation, and that the account number is correct.
                                    Inaccurate/incomplete information or misrepresentation will serve as grounds for denial of loan application.</p>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label>Manner of Release</label>
                                                <select ref="manner_rel" class="form-control custom-select-sm" @change="selectedMR($event)" v-model="formLoan.manner_rel" :class="{'is-invalid': submitting && $v.formLoan.manner_rel.$error}">
                                                    <option :value="null" disabled selected>- Please Select -</option>
                                                    <option v-for="data in filteredMR" :key="data.manner_rel_code" :value="data.manner_rel_code">{{data.manner_rel_desc}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label for="">Account Name</label>
                                                <input type="text" class="form-control form-control-sm text-uppercase" :value="formLoan.acctname" disabled v-if="formLoan.bt_code=='BT2020002' || formLoan.bt_code=='BT2020004'">
                                                <input type="text" class="form-control form-control-sm text-uppercase" v-else v-model="formLoan.acctname" :class="{'is-invalid': submitting && $v.formLoan.acctname.$error}">
                                                <!-- <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.acctname" :class="{'is-invalid': submitting && $v.formLoan.acctname.$error}"> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-row">
                                        <div class="col-sm-6" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                            <div class="form-group">
                                                <label>Bank Name</label>
                                                <v-select append-to-body :calculate-position="withPopper" placeholder="- Select -" label="bankname" :class="{'vs-invalid': submitting && $v.formLoan.bankname.$error }" :options="filteredBank" :reduce="bankname => bankname.bankname" :clearable="false" v-model="formLoan.bankname"></v-select>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group" v-show="formLoan.manner_rel =='GC' || formLoan.manner_rel =='PM'">
                                                <label for="">Registered Mobile Number</label>
                                                <input type="text" class="form-control form-control-sm" v-model="formLoan.acctno" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="" :class="{'is-invalid': submitting && $v.formLoan.acctno.$error}">
                                                <em class="fs-13">Ex. (0912) 3456789</em>
                                                <p class="fs-13 danger m-0 p-0" v-if="submitting && $v.formLoan.acctno.$error">Not a valid Mobile Number</p>
                                            </div>
                                            <div class="form-group" v-show="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                                <label for="">Account Number</label>
                                                <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.acctno" @blur="unmaskAcctNo" :class="{'is-invalid': submitting && $v.formLoan.acctno.$error}">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>{{doc.label}}</label>
                                        <div class="input-group">
                                            <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="ref115" @change="$emit('attach', $event)">
                                            <input type="text" v-if="fetchATT.ATT115 || formATT.ATT115" class="form-control form-control-sm ro" @click="browseRef()" readonly :value="doc.details['file']">
                                            <input type="text" v-else class="form-control form-control-sm ro" readonly value="Choose a file.." :class="{'is-invalid': submitting && $v.formATT.ATT115.$error}" @click="browseRef()">
                                            <div class="input-group-append">
                                                <button class="btn btn-sm btn-outline-primary" @click="browseRef()">
                                                    <span v-if="fetchATT.ATT115 || formATT.ATT115 ">Change</span>
                                                    <span v-else>Attach</span>
                                                </button>
                                                <button v-if="fetchATT.ATT115 || formATT.ATT115" class="btn btn-sm btn-outline-primary ml-2" @click="viewATT(formATT.ATT115, doc.label, fetchATT.ATT115)">View</button>
                                            </div>
                                        </div>

                                        <div class="mt-1">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="progress" v-if="progress.ATT115">
                                                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress.ATT115+ ';'">
                                                            {{progress.ATT115}}
                                                        </div>
                                                    </div>
                                                    <span v-else class="badge" :class="doc.status">{{$parent.attStat(doc.status)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-default" data-dismiss="modal" @click="btnCancel">Cancel</button>
                            <button class="btn btn-primary" @click="btnUpdate">Update</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalATT115" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{attachFile.title}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="col-12" v-if="attachFile.type=='img'">
                                <img :src="attachFile.url" class="img-fluid" alt="Image">
                            </div>
                            <div class="col-12" v-if="attachFile.type=='pdf'">
                                <object :data="attachFile.url + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="PDF" width="100%" height="678">
                                    <div class="alert alert-warning2" role="alert">
                                        <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                                    </div>
                                </object>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" @click="closeModalATT115"><i class="fas fa-times-circle mr-1"></i>Close</button>
                            <button class="btn btn-outline-primary" @click="downloadATT115(attachFile.url, attachFile.name)"><i class="fas fa-download mr-1"></i>Download</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    import {
        createPopper
    } from '@popperjs/core';
    import {
        required,
        minLength,
        requiredIf,
        helpers
    } from 'vuelidate/lib/validators';

    const validateIf = (prop, validator) =>
        helpers.withParams({
            type: 'validatedIf',
            prop
        }, function(value, parentVm) {
            return helpers.ref(prop, this, parentVm) ? validator(value) : true
        })

    export default {
        props: ['formLoan', 'docs', 'formATT', 'fetchATT', 'progress', 'attachFile'],

        data() {
            return {
                doc: this.docs.find(item => item.code === 'ATT115'),
                manner: [],
                banks: [],
                submitting: false,
            }
        },
        validations: {
            formLoan: {
                manner_rel: {
                    required
                },
                bankname: {
                    required: requiredIf(function() {
                        return this.formLoan.manner_rel != "GC" && this.formLoan.manner_rel != "PM";
                    })
                },
                acctname: {
                    required
                },
                acctno: {
                    required,
                    minLength: validateIf('acctmobile', minLength(14))
                },
            },
            formATT: {
                ATT115: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT115;
                    })
                }
            }
        },

        created() {

        },
        methods: {
            async submitForm() {
                const form = {
                    application_id: this.formLoan.application_id,
                    manner_rel: this.formLoan.manner_rel,
                    bankname: this.formLoan.bankname,
                    acctname: this.formLoan.acctname,
                    acctno: this.formLoan.acctno
                };
                let x = await this.$parent.$parent.updateLoanApp(form);
                if (x == 200) {
                    let key = 'ATT115';
                    if (this.formATT[key]) {
                        this.$parent.$parent.payloading = true;
                        const config = {
                            headers: {
                                'content-type': 'multipart/form-data',
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                            },
                            onUploadProgress: function(progressEvent) {
                                this.progress[key] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                            }.bind(this)
                        }
                        let formData = new FormData();
                        formData.append('borrower_id', this.formLoan.borrower_id);
                        formData.append('application_id', this.formLoan.application_id);
                        formData.append('upload_file', this.formATT[key]);
                        formData.append('attach_code', key);

                        await axios.post('/api/v2-upload-attachments', formData, config)
                            .then(res => {
                                let data = res.data.attached;
                                if (data) {
                                    this.formATT[key] = null;
                                    this.progress[key] = 0;
                                    this.doc.status = data.status;
                                    this.doc.details['file'] = data.attach.slice(9);
                                    this.formATT[key] = null;
                                    this.fetchATT[key] = data.filepath + data.attach;
                                }
                                window.URL.revokeObjectURL(this.attachFile.url);
                                this.attachFile.url = null;


                                this.$parent.$parent.payloading = false;
                                $('#modalBank').modal('hide');
                                Fire.$emit('getLoanReq');
                                Fire.$emit('getAttLoanReq');

                            }).catch(err => {
                                this.$parent.$parent.payloading = false;
                            })
                    } else {
                        Fire.$emit('getLoanReq');
                        Fire.$emit('getAttLoanReq');
                        $('#modalBank').modal('hide');
                    }

                }
            },

            browseRef() {
                document.getElementById('ref115').click();
            },
            viewATT(formATT, title, fetchATT) {
                if (formATT) {
                    $('#modalBank').modal('hide');
                    this.$parent.viewAttachFile(formATT, title, '#modalATT115');
                }
                if (fetchATT) {
                    $('#modalBank').modal('hide');
                    this.$parent.viewFetch(fetchATT, title, '#modalATT115', 2);
                }
            },
            closeModalATT115() {
                window.URL.revokeObjectURL(this.attachFile.url);
                $('#modalATT115').modal('hide');
                for (let k in this.attachFile) {
                    this.attachFile[k] = null;
                }
                $('#modalBank').modal('show');
            },
            downloadATT115(fileURL, name) {
                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', name.slice(name.length - 22));
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(fileURL);
            },
            withPopper(dropdownList, component, {
                width,
                top,
                left
            }) {

                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;


                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: 'top',
                    modifiers: [{
                            name: 'offset',
                            options: {
                                offset: [0, -1]
                            }
                        },
                        {
                            name: 'toggleClass',
                            enabled: true,
                            phase: 'write',
                            fn({
                                state
                            }) {
                                component.$el.classList.toggle('drop-up', state.placement === 'top')
                            },
                        }
                    ]
                });
                return () => popper.destroy();
            },

            btnUpdate: _.debounce(function() {
                this.postLoanProceeds();
            }, 333),
            btnCancel() {
                this.submitting = false;
                Fire.$emit('getLoanReq');
                Fire.$emit('getAttLoanReq');
            },
            postLoanProceeds() {
                this.submitting = true;
                this.$v.formATT.$touch();
                this.$v.formLoan.$touch();
                if (this.$v.formATT.$invalid || this.$v.formLoan.$invalid) {
                    // condition
                } else {
                    this.submitForm();
                }
            },
            selectedMR(e) {
                this.formLoan.bankname = null;
                this.formLoan.acctno = null;
                this.formLoan.acctmobile = this.reqAcctNo;
            },
            unmaskAcctNo() {
                let val = this.formLoan.acctno;
                if (val) {
                    this.formLoan.acctno = val.replace(/[^a-zA-Z0-9]/g, "");
                }
            },
            getLoanProceeds() {
                this.$parent.$parent.payloading = true;
                axios.get('/api/v2-ref-loan-proceed-b2c')
                    .then(res => {
                        let data = res.data
                        this.manner = data.manner;
                        this.banks = data.banks;
                        this.formLoan.acctmobile = this.reqAcctNo; //adding properties on parent props
                        this.$parent.$parent.payloading = false;
                    })
                    .catch(err => {
                        this.$parent.$parent.payloading = false;
                    })
            },

        },
        computed: {
            reqAcctNo() {
                let required = false;
                if (this.formLoan.manner_rel == "GC" || this.formLoan.manner_rel == "PM") {
                    required = true
                }
                return required;
            },
            filteredBank() {
                let data_banks = this.banks;
                if (this.formLoan.manner_rel == "IP") {
                    let instapay_data = data_banks.filter(function(item) {
                        return item.instapay == 'Y';
                    });
                    return instapay_data;
                }
                if (this.formLoan.manner_rel == "PN") {
                    let pesonet_data = data_banks.filter(function(item) {
                        return item.pesonet == 'Y';
                    });
                    return pesonet_data;
                }

                if (this.formLoan.manner_rel == "FT") {
                    let bankname = [{
                        'bankname': 'LAND BANK OF THE PHILIPPINES'
                    }];
                    return bankname;
                }
                if (this.formLoan.manner_rel == "CC") {
                    let ft_data = data_banks.filter(function(item) {
                        return item.bankname == 'LAND BANK OF THE PHILIPPINES';
                    });
                    return ft_data;
                }
            },
            filteredMR() {
                let list = this.manner;
                let amount = this.formLoan.req_loan_amt;
                let filter = null;
                if (amount > 50000) {
                    filter = list.filter(function(item) {
                        return item.manner_rel_code == 'FT' || item.manner_rel_code == 'PN';
                    });
                    return filter;
                } else if (amount <= 30000) {
                    return list;
                } else {

                    filter = list.filter(function(item) {
                        return item.manner_rel_code == 'FT' || item.manner_rel_code == 'PN' || item.manner_rel_code == 'IP';
                    });
                    return filter;
                }
            },
        },
        mounted() {}
    }
</script>



<style scoped>

</style>